export default __webpack_public_path__ + "static/media/PEGI_11.17334daf.svg";